"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderIdFromQuerystring = exports.getOrderIdFromCookie = exports.getMessageDataFromCookie = exports.getHostDomain = exports.deleteOrderIdCookie = exports.deleteMessageDataCookie = exports.captureEcomEvent = void 0;
var _util = require("@ux/util");
/**
 * Pulls proper host domain (EX: godaddy.com).
 *
 * @param {Object} windowObject Represents the browser's window
 *
 * @public
 *
 * @returns { string | null } Domain
 */

const getHostDomain = windowObject => {
  if (windowObject) {
    const hostDomain = windowObject.location.hostname;
    const hostnameParts = hostDomain.split('.');
    const len = hostnameParts.length;
    if (len > 2) {
      return hostnameParts[len - 2] + '.' + hostnameParts[len - 1];
    }
    return hostDomain;
  }
  return null;
};

/**
 * Pulls order ID out of query string.
 *
 * @param {Object} windowObject Represents the browser's window
 *
 * @public
 *
 * @returns { string | null } Order id
 */
exports.getHostDomain = getHostDomain;
const getOrderIdFromQuerystring = windowObject => {
  const searchObject = windowObject && windowObject.location && windowObject.location.search ? windowObject.location.search : null; // eslint-disable-line max-len
  const results = new RegExp('[\\?&]orderId=([^&#]*)', 'i').exec(searchObject);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Pulls order ID from cookie.
 *
 * @public
 *
 * @returns { string } OrderID
 */
exports.getOrderIdFromQuerystring = getOrderIdFromQuerystring;
const getOrderIdFromCookie = () => {
  // Current utag cookie name orderId
  return _util.cookie.getItem('orderId');
};

/**
 * Parses message data from cookie
 *
 * @param {string} orderNumber Individual order identifier
 *
 * @public
 *
 * @returns { Object | null } Message data
 */
exports.getOrderIdFromCookie = getOrderIdFromCookie;
const getMessageDataFromCookie = orderNumber => {
  // Current utag cookie name pd + orderNumber
  if (orderNumber && orderNumber.length > 0) {
    try {
      return JSON.parse(_util.cookie.getItem(`pd${orderNumber}`));
    } catch (e) {
      return {};
    }
  }
  return null;
};

/**
 * Delete cookie message data.
 *
 * @param {Object} windowObject Represents the browser's window
 * @param {string} orderNumber Individual order identifier
 *
 * @public
 *
 * @returns { promise | null } Message data
 */
exports.getMessageDataFromCookie = getMessageDataFromCookie;
const deleteMessageDataCookie = (windowObject, orderNumber) => {
  // Current utag cookie name pd + orderNumber
  if (orderNumber && orderNumber.length > 0) {
    // Return null if undefined
    return _util.cookie.remove(`pd${orderNumber}`, {
      path: '/',
      domain: getHostDomain(windowObject)
    }) || null; // eslint-disable-line max-len
  }
};

/**
 * Delete cookie orderId.
 *
 * @param {Object} windowObject Represents the browser's window
 *
 * @public
 * @returns { promise | null } Message data
 */
exports.deleteMessageDataCookie = deleteMessageDataCookie;
const deleteOrderIdCookie = windowObject => {
  // Current utag cookie name orderId
  // Return null if undefined
  return _util.cookie.remove('orderId', {
    path: '/',
    domain: getHostDomain(windowObject)
  }) || null; // eslint-disable-line max-len
};

/**
 * Verify event data was captured.
 *
 * @param {Object} windowObject Represents the browser's window
 * @param {string} orderData Order information
 *
 * @public
 *
 * @returns { boolean } true if event captured
 */
exports.deleteOrderIdCookie = deleteOrderIdCookie;
const captureEcomEvent = (windowObject, orderData) => {
  if (orderData && typeof windowObject._expDataLayer === 'object') {
    windowObject._expDataLayer.push(orderData);
    return true;
  }
  return false;
};
exports.captureEcomEvent = captureEcomEvent;